export const ON_BRIGHT = 'on-bright';
export const DEFAULT = 'default';
export const ERROR = 'error';